<template>
  <el-dropdown trigger="hover" class="international" @command="handleSetLanguage" placement="bottom-start">
    <div>
      <!-- <svg-icon class-name="international-icon" icon-class="language" style="width: 25px;height: 25px;" /> -->
      <img src="@/assets/uupay/icon/svg/lg.svg" alt="">
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='tw'" command="tw">
        繁體中文
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='zh'" command="zh" divided>
        简体中文
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en" divided>
        English
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
      // this.$message({
      //   message: this.$t('common.setLgSuccess'),
      //   type: 'success',
      //   onClose() {
      //     // location.reload()
      //   }
      // })
      // location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
.international {
  margin-right: 2.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/LangSelect.vue